import React from "react";
import Icon from "@/components/ui/AppIcon";

type IPType = "patent" | "trademark" | "copyright" | "design" | "special_case";

interface IPTypeBadgeProps {
  type?: string | null;
  size?: "sm" | "md";
  showIcon?: boolean;
}

const ipConfig: Record<IPType, { label: string; className: string; icon: string }> = {
  patent: {
    label: "Patent",
    className: "bg-blue-50 text-blue-700 border-blue-200",
    icon: "LightBulbIcon",
  },
  trademark: {
    label: "Trademark",
    className: "bg-violet-50 text-violet-700 border-violet-200",
    icon: "TagIcon",
  },
  copyright: {
    label: "Copyright",
    className: "bg-amber-50 text-amber-700 border-amber-200",
    icon: "DocumentTextIcon",
  },
  design: {
    label: "Design",
    className: "bg-sky-50 text-sky-700 border-sky-200",
    icon: "SparklesIcon",
  },
  special_case: {
    label: "Special Case",
    className: "bg-rose-50 text-rose-700 border-rose-200",
    icon: "BriefcaseIcon",
  },
};

const normalizeType = (value?: string | null) => {
  if (!value) return "patent";

  const normalized = value.toLowerCase().trim().replace(/\s+/g, "_");
  if (normalized === "special-case") return "special_case";
  if (normalized === "design") return "design";
  if (normalized === "copyright") return "copyright";
  if (normalized === "trademark") return "trademark";
  if (normalized === "patent") return "patent";

  return "patent";
};

export default function IPTypeBadge({ type, size = "md", showIcon = true }: IPTypeBadgeProps) {
  const config = ipConfig[type as IPType];
  return (
    <span
      className={`
        inline-flex items-center gap-1 font-600 border rounded-md
        ${size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5"}
        ${config?.className || "bg-gray-50 text-gray-700 border-gray-200"}
      `}
    >
      {showIcon && config?.icon && <Icon name={config.icon as any} size={size === "sm" ? 10 : 12} />}
      {config?.label || type || "Unknown"}
    </span>
  );
}